/**
 * Shares the same code & functionality as the addHttps function within global mixins.
 * @param link
 * @returns
 */
export function addHttps(link: string): string {
  if (typeof link === 'string') {
    if (!link.startsWith('http://') && !link.startsWith('https://'))
      return `https://${link}`
    else return link
  } else {
    return ''
  }
}
